import styled from '@mui/material/styles/styled';
import Alert from '@mui/material/Alert';

export const SuccessAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: theme.palette.primary.light,
    color: '#FFFFFF',
    fontFamily: 'Roboto-Medium'
}))

export const ErrorAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.light,
    color: '#FFFFFF',
    fontFamily: 'Roboto-Medium'
}))

export const WarningAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: '#FACA30',
    color: '#FFF',
    fontFamily: 'Roboto-Medium'
}))